import { useIntl } from 'react-intl';
import { formatCurrency } from '../../utils/helpers';

export interface IAffordableLoan {
  potentialAmountOfLoan?: number;
  potentialMonthlyRateLoan?: number;
  monthlyRateLoan?: number;
  amountOfLoan?: number;
}

interface IAffordableLoanInfoProps {
  myBudget: IAffordableLoan;
}

const AffordableLoanInfo = ({ myBudget }: IAffordableLoanInfoProps) => {
  const { formatMessage: t } = useIntl();
  const { monthlyRateLoan, amountOfLoan } = myBudget;
  return (
    <table className="table last-col-text-right">
      <thead>
        <tr>
          <td colSpan={2}>
            <h4>{t({ id: 'budget.titles.affordable_loan' })}</h4>
          </td>
          <td />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{t({ id: 'budget.titles.monthly_repayments' })}</td>
          <td>{Number(monthlyRateLoan) > 0 ? formatCurrency(monthlyRateLoan) : 0}</td>
        </tr>
        <tr>
          <td>{t({ id: 'budget.titles.total_loan_amount' })}</td>
          <td>{Number(amountOfLoan) > 0 ? formatCurrency(amountOfLoan) : 0}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default AffordableLoanInfo;
